// #1715 — Load the Google Maps JS API (Places library) exactly once, using the
// referrer-restricted BROWSER key fetched from the backend. Returns a cached promise
// that resolves with window.google.maps. Rejects if the key is not configured.
import service from '../services.js';

let mapsPromise = null;

export function loadGoogleMaps() {
  if (mapsPromise) return mapsPromise;

  mapsPromise = new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      return resolve(window.google.maps);
    }
    service
      .get('config/maps-browser-key', {})
      .then((res) => {
        const key = (res && res.data && res.data.result && res.data.result.key) || '';
        if (!key) {
          return reject(new Error('Google Maps browser key not configured'));
        }
        const cb = '__gmapsReady_' + Date.now();
        window[cb] = () => resolve(window.google.maps);
        const s = document.createElement('script');
        s.src =
          'https://maps.googleapis.com/maps/api/js?key=' +
          encodeURIComponent(key) +
          '&libraries=places&callback=' +
          cb;
        s.async = true;
        s.defer = true;
        s.onerror = () => reject(new Error('Google Maps JS failed to load'));
        document.head.appendChild(s);
      })
      .catch(reject);
  });

  return mapsPromise;
}
